export const GithubIcon = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_191_27203)">
      <circle
        cx="20.1111"
        cy="20"
        r="20"
        fill="#55111E"
      />
      <path
        d="M16.9319 31.0441C16.9319 30.676 16.9187 29.7021 16.9104 28.41C12.5667 29.3454 11.6493 26.3342 11.6493 26.3342C10.9402 24.5454 9.91546 24.0691 9.91546 24.0691C8.49646 23.1091 10.0212 23.1288 10.0212 23.1288C11.589 23.2386 12.4129 24.7241 12.4129 24.7241C13.8071 27.0893 16.0699 26.4072 16.96 26.0104C17.1005 25.0102 17.5046 24.3273 17.9517 23.9404C14.484 23.5485 10.8378 22.2204 10.8378 16.289C10.8378 14.5986 11.4468 13.2164 12.446 12.1326C12.284 11.7415 11.7493 10.1658 12.5981 8.03593C12.5981 8.03593 13.9105 7.61946 16.8931 9.62228C18.1385 9.27877 19.474 9.76329 20.8038 9.75755C22.1294 9.76574 23.4657 9.27877 24.7136 9.62392C27.6954 7.62192 29.0053 8.03839 29.0053 8.03839C29.8566 10.1707 29.3219 11.744 29.1615 12.135C30.1632 13.218 30.7656 14.6002 30.7656 16.2915C30.7656 22.2384 27.1144 23.5469 23.636 23.9305C24.1963 24.4093 24.6955 25.3529 24.6955 26.7974C24.6955 28.8683 24.6756 30.5374 24.6756 31.0449C24.6756 31.24 24.5806 32 20.8021 32C17.0236 32 16.9303 31.2482 16.9303 31.0449L16.9319 31.0441Z"
        fill="#FE0021"
      />
    </g>
    <defs>
      <clipPath id="clip0_191_27203">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(0.111084)"
        />
      </clipPath>
    </defs>
  </svg>
);
